//javascript voor de security om een password recovery button te kunnen hebben die niet reageert op 'enter' in een
// form


// run functie als pagina geladen is
window.addEventListener('load', security_lookForPRButton);
window.addEventListener('load', security_disableWarning);
window.addEventListener('load', security_cookieTest);
window.addEventListener('load', security_disableSubmitAfterSubmit);
window.addEventListener('load', security_loopLanguages);


/**
 * als je auto-login doet met iOS moet je daarna niet nog eens met de hand submit klikken want
 * dan krijg je een CSRF melding en moet je nog eens inloggen
 */
function security_disableSubmitAfterSubmit() {
	var loginForm = document.getElementById('securityLoginForm');
	if (!loginForm) return;
	
	//dit is niet disabledSubmitAfterSubmit maar dat als je naar de #passwordrecovery gaat dat de autofocus
	// op de username wordt overridden
	var passwordRecovery = document.getElementById('securityPRMailAddress');
	if (passwordRecovery !== null) {
		if (window.location.hash == '#passwordrecovery') {
			//met timeout anders wint 'autofocus' attribuut op username input
			setTimeout(function() {
				passwordRecovery.focus();
				passwordRecovery.scrollIntoView();
			}, 500);
		}
	}
	
	
	loginForm.addEventListener('submit', function() {
		var securitySubmit = document.getElementById('securitySubmit');
		if (!securitySubmit) return;
		
		securitySubmit.disabled = true;
		
		//reload na twintig secondes just in case zodat je niet stuck raakt met een disabled login button
		setTimeout(function() {window.location = window.location.href}, 20000);
		return true;
	});
}


function security_lookForPRButton() {
	var buttonInp = document.getElementById('security-prButton');
	var userIVInp = document.getElementById('security-prIV');
	var userEmInp = document.getElementById('security-prEmail');
	var realmInp  = document.getElementById('security-prRealm');
	
	if (!buttonInp) return;
	if (!userIVInp) return;
	if (!userEmInp) return;
	if (!realmInp)  return;
	
	buttonInp.addEventListener('click',function() {
		security_postPRForm(userIVInp.value, userEmInp.value, realmInp.value);
	});
}


//voegt een eigen form toe aan de pagina en submit dat form zodat we niet met een GET url komen te zitten
function security_postPRForm(IV, email, realm) {
	
	var form = document.createElement('form');
	form.setAttribute('method', 'post');
	form.setAttribute('action', '');
	
	//add userID
	var hiddenField = document.createElement('input');
	hiddenField.setAttribute('type', 'hidden');
	hiddenField.setAttribute('name', 'security[sendPasswordReset]');
	form.appendChild(hiddenField);
	
	hiddenField = document.createElement('input');
	hiddenField.setAttribute('type', 'hidden');
	hiddenField.setAttribute('name', 'security[prIV]');
	hiddenField.setAttribute('value', IV);
	form.appendChild(hiddenField);
	
	hiddenField = document.createElement('input');
	hiddenField.setAttribute('type', 'hidden');
	hiddenField.setAttribute('name', 'security[prEmail]');
	hiddenField.setAttribute('value', email);
	form.appendChild(hiddenField);

	hiddenField = document.createElement('input');
	hiddenField.setAttribute('type', 'hidden');
	hiddenField.setAttribute('name', 'security[prRealm]');
	hiddenField.setAttribute('value', realm);
	form.appendChild(hiddenField);
	
	document.body.appendChild(form); 
	form.submit();
}


function security_disableWarning() {
	var span = document.getElementById('securityNoJsWarning');
	if (span) span.style.display = 'none';
}


//laat een <div> zien (verwijdert display none) als cookies niet toegestaan zijn bij het inlogscherm
// voorkomt dat je naar een wit scherm zonder melding zit te staren
function security_cookieTest() {
	var div = document.getElementById('securityCookieTest');
	
	//zelfde code in securityFunctions.php / security_testWarnCookiesEnabled()
	var hasCookies = security_cookiesEnabled();
	
	if (!hasCookies) div.style.display = 'block';
}


//https://github.com/Modernizr/Modernizr/blob/v3.6.0/feature-detects/cookies.js
//https://stackoverflow.com/questions/4603289/how-to-detect-that-javascript-and-or-cookies-are-disabled
//https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
function security_cookiesEnabled() {
	try {
		document.cookie = 'cookies_enabled=1; SameSite=lax';
		var ret = document.cookie.indexOf('cookies_enabled=') != -1;
		document.cookie = 'cookies_enabled=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=lax';
		return ret;
	}
	catch (e) {
		return false;
	}
}


//loop door alle meegegeven talen in de lijst
function security_loopLanguages() {
	var lang = document.querySelectorAll("[data-other-languages]");
	
	lang.forEach(function(el) {
		el.style.transition = 'opacity 1s ease';
		var ol = JSON.parse(el.dataset.otherLanguages);
		setInterval(function() {
			el.style.opacity = 0.25;
			setTimeout(function() {
				el.innerHTML = ol[Math.floor(Math.random() * ol.length)];
				el.style.opacity = 1;
			}, 1000);
		}, 7500);
	});
	
}

